import { debug } from "../../utils";

export const ACTION_PARAMETER_CHANGED = "ACTION_PARAMETER_CHANGED";
export const ACTION_STATE_CLEANED = "ACTION_STATE_CLEANED";
export const ACTION_LAST_PARAMETER_LOAD_CHANGED = "ACTION_LAST_PARAMETER_LOAD_CHANGED";
export const ACTION_PARAMETER_REVERTED = "ACTION_PARAMETER_REVERTED";

const initState = {
    parameters: [],
    lastParameterLoad: 0
}

export function ParametersPageReducer(state = initState, action) {
    switch (action.type) {
        case ACTION_PARAMETER_CHANGED: {
            debug(`ManageParametersPageReducer ${ACTION_PARAMETER_CHANGED} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_LAST_PARAMETER_LOAD_CHANGED: {
            debug(`ManageParametersPageReducer ${ACTION_LAST_PARAMETER_LOAD_CHANGED} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_PARAMETER_REVERTED: {
            debug(`ManageParametersPageReducer ${ACTION_PARAMETER_REVERTED} is being processed...`)
            return { ...state, ...initState };
        }
        case ACTION_STATE_CLEANED: {
            debug(`ManageParametersPageReducer ${ACTION_STATE_CLEANED} is being processed...`)
            return initState;
        }
        default:
            return state;
    }
}
